import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageSubtitle } from "../components/lux";
import LeaderboardBoard from "../components/affiliates/LeaderboardBoard";
import ChallengeCard from "../components/affiliates/ChallengeCard";
import { Trophy } from "@phosphor-icons/react";

const monthKey = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;

/** Affiliate-facing view: this month's standings + every live challenge. */
export default function AffiliateLeaderboard() {
  const [month, setMonth] = useState(monthKey(new Date()));
  const [board, setBoard] = useState(null);
  const [challenges, setChallenges] = useState([]);

  useEffect(() => {
    api.get(`/affiliates/leaderboard?month=${month}`).then(({ data }) => setBoard(data)).catch(() => {});
  }, [month]);

  useEffect(() => {
    api.get("/affiliates/challenges?include_inactive=false")
      .then(({ data }) => setChallenges(data || []))
      .catch(() => {});
  }, []);

  return (
    <div className="space-y-8" data-testid="affiliate-leaderboard-page">
      <PageSubtitle>Every booking with your name on it counts — here&apos;s where everyone stands</PageSubtitle>

      <LeaderboardBoard board={board} month={month} onMonth={setMonth} testid="affiliate-leaderboard" />

      <div>
        <div className="flex items-center gap-2 mb-4">
          <Trophy size={18} className="text-primary" />
          <h2 className="font-heading text-2xl">Challenges</h2>
        </div>
        {challenges.length === 0 ? (
          <div className="border border-border bg-card p-8 text-center" data-testid="no-challenges">
            <p className="text-sm text-muted-foreground">No challenges running right now — check back soon.</p>
          </div>
        ) : (
          <div className="space-y-4" data-testid="affiliate-challenge-list">
            {challenges.map((ch) => <ChallengeCard key={ch.id} challenge={ch} />)}
          </div>
        )}
      </div>
    </div>
  );
}
